// extracted by mini-css-extract-plugin
export default {"videoModal":"G_dVtiLCizkmIvSa4cwg","videoBox":"aSu5hvPNMWh4zciPrOp1","closeBtn":"cuRlZkUT71ftl05OFQBz"};